module.exports = __webpack_public_path__ + "static/media/arrow_up_Gray.a55add84.svg";